<template>
  <transition name='slide-fade'>
    <div class='page-component-up' v-if='isShow' @click='getTop'>
      <span v-show="backTop">返回顶部</span>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'BackTop',
  data () {
    return {
      isShow: false,
      backTop: false
    }
  },
  methods: {
    //  添加样式，鼠标hover上去，改变颜色
    addhoverClass (e) {
      if (e.type === 'mouseover' && this.$el.classList) {
        this.$el.classList.add('hover')
        this.backTop = true
      } else if (e.type === 'mouseout' && this.$el.classList) {
        this.$el.classList.remove('hover')
        this.backTop = false
      }
    },
    showIcon () {
      if (document.documentElement.scrollTop > 500) {
        this.isShow = true
        this.backTop = false
        this.$el.addEventListener('mouseover', this.addhoverClass)
        this.$el.addEventListener('mouseout', this.addhoverClass)
      } else if (document.documentElement.scrollTop < 500) {
        this.isShow = false
        this.backTop = false
      }
    },
    getTop () {
      let timer = setInterval(() => {
        let top = document.documentElement.scrollTop
        let speed = Math.ceil(top / 3)
        document.documentElement.scrollTop = top - speed
        if (top === 0) {
          clearInterval(timer)
        }
      }, 20)
    }
  },
  mounted () {
    window.addEventListener('scroll', this.showIcon)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.showIcon)
  }
}
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all .1s ease;
}
.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.3, 0.8, 1.0);
  opacity: 0;
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 在低于 2.1.8 版本中 */ 
{ 
  transform: translateY(-20px);
  opacity: 0;
}
.page-component-up {
  position: fixed;
  right: 30px;
  bottom: 100px;
  width: 54px;
  height: 54px;
  /* background-color: #31a7f1; */
  box-shadow: 0 0 8px #e9e9e9;
  background: url(../assets/imgs/backTop.png) center no-repeat;
  cursor: pointer;
  transition: .3s;
  text-align: center;
  padding: 5px;
  z-index: 99999;
}
span{
  font-size: 15px;
}
/* .el-icon-caret-top {
  font-size: 36px;
  margin-top: 7px;
  color: #FFFFFF;
  text-align: center;
  z-index: 1000
} */
.hover {
  background:#31a7f1;
  color:#fff; 
  font-size:14px;
  font-family: '微软雅黑';
}
</style>